/* eslint-disable @typescript-eslint/no-non-null-assertion */
import {TrackingPageContext, TrackingSectionContext} from '../../../types';
import {TrackingClientStateHolder} from '../helpers/clientState';
import {shouldPushToDataLayerObject} from '../helpers/datalayer';
import {debugWarn} from '../helpers/log';
import {pageKey} from '../helpers/pageKey';
import {stringifyEventData} from '../helpers/stringifyEventData';

interface RecoListEvent {
  event: 'recoList';
  action: string;
  label: string;
  value: null;
}

const updateFiredRecoState = ({
  clientState,
  page,
  section,
}: {
  clientState: TrackingClientStateHolder;
  page: TrackingPageContext;
  section: TrackingSectionContext;
}) => {
  const currentState = clientState.getCurrent();

  if (!currentState.firedRecoLists[pageKey(page)]) {
    return clientState.update({
      firedRecoLists: {
        ...currentState.firedRecoLists,
        [pageKey(page)]: [section.sectionIndexOnPage],
      },
    });
  } else {
    return clientState.update({
      firedRecoLists: {
        ...currentState.firedRecoLists,
        [pageKey(page)]: [
          ...currentState.firedRecoLists[pageKey(page)]!,
          section.sectionIndexOnPage,
        ],
      },
    });
  }
};

export const trackRecoList =
  (clientState: TrackingClientStateHolder) =>
  ({section}: {section: TrackingSectionContext}) => {
    let currentState = clientState.getCurrent();
    const {currentPage} = currentState;
    if (!currentPage || currentPage.type === 'initial') {
      debugWarn('tried to track reco list event before page view');
      return;
    }

    const firedRecosForPage =
      currentState.firedRecoLists[pageKey(currentPage.page)];

    // Don't fire reco event if it has been tracked before
    const fireEventReco = !(
      firedRecosForPage &&
      firedRecosForPage.includes(section.sectionIndexOnPage)
    );

    if (fireEventReco) {
      // Mark section as tracked
      currentState = updateFiredRecoState({
        clientState,
        page: currentPage.page,
        section,
      });

      const recoElementsIds =
        section.type === 'reco'
          ? section.elements.map(element => element.id)
          : [];

      const event: RecoListEvent = {
        event: 'recoList',
        action: stringifyEventData([
          section.type === 'reco' ? section.recoType : '',
          section.type === 'reco' ? section.headline : '',
          recoElementsIds.length,
        ]),
        label: stringifyEventData(recoElementsIds),
        value: null,
      };

      shouldPushToDataLayerObject(event, clientState);
    }
  };
